import { render, staticRenderFns } from "./SidebarCoupon.vue?vue&type=template&id=4f8e7bdd&scoped=true"
import script from "./SidebarCoupon.vue?vue&type=script&lang=js"
export * from "./SidebarCoupon.vue?vue&type=script&lang=js"
import style0 from "./SidebarCoupon.vue?vue&type=style&index=0&id=4f8e7bdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8e7bdd",
  null
  
)

export default component.exports